import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  Validators,
  FormGroup,
} from "@angular/forms";
import { ApiService } from "src/app/services/api/api.service";
import { map } from "rxjs/operators";

@Component({
  selector: "app-bank-details",
  templateUrl: "./bank-details.component.html",
  styleUrls: ["./bank-details.component.scss"],
})
export class BankDetailsComponent implements OnInit {
  private bankDetailsForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.bankDetailsForm = this.formBuilder.group({
      bank: new FormControl("", [Validators.required]),
      account_number: new FormControl("", [Validators.required]),
    });
  }

  onSubmit() {
    this.apiService
      .post("bank-details", this.form.value)
      .pipe(map((response: any) => response.data))
      .subscribe((data) => {
        // console.log(data);
      });
  }

  get form() {
    return this.bankDetailsForm;
  }
}
